<template>
  <div
    class="zm-tag-group"
    role="group"
    @keydown="handleKeyDown"
  >
    <slot></slot>
  </div>
</template>

<script>
  import AriaUtils from '../../utils/aria-utils';
  import { findVueComponents } from '../../utils/util';
  export default {
    name: 'ZmTagGroup',
    componentName: 'ZmTagGroup',
    data() {
      return {
        activeIndex: 0,
        firstClosable: -1
      };
    },
    computed: {
      childrenTags() {
        return findVueComponents(this, 'ZmTag');
      },
      closable() {
        return this.childrenTags.some(tag => {
          return tag.closable;
        });
      }
    },
    methods: {
      handleKeyDown(event) {
        const keyCode = event.keyCode;
        const keys = AriaUtils.keys;
        switch (keyCode) {
          case keys.enter:
            this.handleEnter(event);
            event.preventDefault();
            event.stopPropagation();
            break;
          case keys.down:
          case keys.right:
            this.navigateOptions('next');
            event.preventDefault();
            event.stopPropagation();
            break;
          case keys.up:
          case keys.left:
            this.navigateOptions('prev');
            event.preventDefault();
            event.stopPropagation();
            break;
          case keys.home:
            this.navigateOptions('home');
            event.preventDefault();
            event.stopPropagation();
            break;
          case keys.end:
            this.navigateOptions('end');
            event.preventDefault();
            event.stopPropagation();
            break;
          case keys.backspace:
          case keys.delete:
            this.handleDelete(event);
            event.preventDefault();
            event.stopPropagation();
            break;
        }
      },

      handleDelete(event) {
        const target = this.childrenTags[this.activeIndex];
        if (target && target.closable) {
          target.handleClose(event, target);
        }
      },
      handleEnter(event) {
        const target = this.childrenTags[this.activeIndex];
        target.handleEnter(event, target);
      },

      navigateOptions(direction) {
        if (direction === 'next') {
          this.activeIndex++;
          if (this.activeIndex >= this.childrenTags.length) {
            this.activeIndex = 0;
          }
        } else if (direction === 'prev') {
          this.activeIndex--;
          if (this.activeIndex < 0) {
            this.activeIndex = this.childrenTags.length - 1;
          }
        } else if (direction === 'home') {
          this.activeIndex = 0;
        } else if (direction === 'end') {
          this.activeIndex = this.childrenTags.length - 1;
        }
      }
    }
  };
</script>

<style scoped>

</style>
